/**
 * JWT token storage. localStorage + Bearer header (per CLAUDE.md rule #9).
 *
 * NEVER move to cookies without a full security review — Mirim broke
 * production login for days when someone tried that.
 */

const ACCESS_KEY = "ps_access";
const REFRESH_KEY = "ps_refresh";

function safeStorage(): Storage | null {
  if (typeof localStorage === "undefined") return null;
  try {
    // Some browsers throw in private mode
    localStorage.setItem("__ps_test__", "1");
    localStorage.removeItem("__ps_test__");
    return localStorage;
  } catch {
    return null;
  }
}

export function getAccessToken(): string | null {
  return safeStorage()?.getItem(ACCESS_KEY) ?? null;
}

export function getRefreshToken(): string | null {
  return safeStorage()?.getItem(REFRESH_KEY) ?? null;
}

export function setTokens(access: string, refresh: string): void {
  const s = safeStorage();
  if (!s) return;
  s.setItem(ACCESS_KEY, access);
  s.setItem(REFRESH_KEY, refresh);
}

export function clearTokens(): void {
  const s = safeStorage();
  if (!s) return;
  s.removeItem(ACCESS_KEY);
  s.removeItem(REFRESH_KEY);
}

export function isAuthenticated(): boolean {
  return getAccessToken() !== null;
}
